/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { dateFormat } from "~/constants/dateFormat";
import { periodDayJs } from "~/services/customers";

type ApplicationStatusData = {
  color: "success" | "danger" | "warning";
  icon: "forecastDown" | "forecastUp" | "help";
  tooltip: string;
};

export const getApplicationStatus = (
  forecastToPrev: number
): ApplicationStatusData => {
  const prevMonth = periodDayJs()
    .subtract(1, "month")
    .format(dateFormat.monthYear);

  if (forecastToPrev > 100) {
    return {
      color: "danger",
      icon: "forecastUp",
      tooltip: `${Math.floor(
        forecastToPrev - 100
      )}% more compared to ${prevMonth}`,
    };
  }

  if (forecastToPrev > 0) {
    return {
      color: "success",
      icon: "forecastDown",
      tooltip: `${
        100 - Math.floor(forecastToPrev)
      }% less compared to ${prevMonth}`,
    };
  }

  return {
    color: "warning",
    icon: "help",
    tooltip: `Can't compare to ${prevMonth}`,
  };
};
